<template>
  <content-loader
    view-box="0 0 420 185"
    :speed="2"
    primary-color="#f3f3f3"
    secondary-color="#ecebeb"
    height="155"
  >
    <rect x="54" y="14" rx="0" ry="0" width="184" height="5" /> 
    <rect x="54" y="22" rx="0" ry="0" width="108" height="4" /> 
    <rect x="60" y="61" rx="0" ry="0" width="120" height="53" /> 
    <rect x="54" y="37" rx="0" ry="0" width="1" height="110" /> 
    <rect x="54" y="147" rx="0" ry="0" width="133" height="1" /> 
    <rect x="186" y="37" rx="0" ry="0" width="1" height="110" /> 
    <rect x="54" y="36" rx="0" ry="0" width="133" height="1" /> 
    <rect x="53" y="121" rx="0" ry="0" width="133" height="1" /> 
    <rect x="59" y="128" rx="0" ry="0" width="120" height="14" /> 
    <rect x="55" y="54" rx="0" ry="0" width="132" height="1" /> 
    <rect x="79" y="43" rx="0" ry="0" width="75" height="5" /> 
    <rect x="208" y="37" rx="0" ry="0" width="1" height="110" /> 
    <rect x="208" y="147" rx="0" ry="0" width="131" height="1" /> 
    <rect x="208" y="36" rx="0" ry="0" width="132" height="1" /> 
    <rect x="339" y="37" rx="0" ry="0" width="1" height="110" /> 
    <rect x="209" y="54" rx="0" ry="0" width="131" height="1" /> 
    <rect x="235" y="43" rx="0" ry="0" width="75" height="5" /> 
    <rect x="214" y="61" rx="0" ry="0" width="120" height="53" /> 
    <rect x="209" y="121" rx="0" ry="0" width="130" height="1" /> 
    <rect x="214" y="127" rx="0" ry="0" width="120" height="14" />
  </content-loader>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
    name: "PackageLoader",
    components: { ContentLoader }
};
</script>